import {
  createRouter,
  createWebHashHistory,
  createWebHistory
} from 'vue-router'
import login from '@/views/login/login.vue'
import main from '@/views/main.vue'
//以下舍弃
import bdc from '@/views/main/bdc.vue'

//以上舍弃
import department from '@/views/page/department.vue'
import role from '@/views/page/role.vue'
import rolefenpei from '@/views/page/rolefenpei.vue'
import fpbmzy from '@/views/page/allocationDepartment.vue'
import risk from '@/views/page/risk.vue'
import zygl from '@/views/page/explorer.vue'
import finallist from '@/views/main/finallist.vue'
import risklist from '@/views/main/risklist.vue'
import platformInstitutions from '@/views/main/platformInstitutions.vue'
//APIKEY管理页面
import apikeyplatformInstitutions from '@/views/main/apikeyplatformInstitutions.vue'
//订阅管理
import SubscriptionManagement from '@/views/main/SubscriptionManagement.vue'
//ip白名单管理
import ipwhiteplatformInstitutions from '@/views/main/ipwhiteplatformInstitutions.vue'
//ca授权管理
import casend from '@/views/main/casend.vue'
//数据管理
import data from '@/views/main/data.vue'


import { name } from '@/js/yz'

const routes = [{
    path: '/',
    name: 'main',
    component: main,
    children: [{
        path: '',
        name: 'data',
        component: data,
      },
      {
        path: '/department',
        name: 'department',
        component: department
      }, {
        path: '/role',
        name: 'role',
        component: role
      }, {
        path: '/rolefenpei',
        name: 'rolefenpei',
        component: rolefenpei
      }, {
        path: '/risk',
        name: 'risk',
        component: risk
      }, {
        path: '/bdc',
        name: 'bdc',
        component: bdc
      },
      {
        path: '/fpbmzy',
        name: 'fpbmzy',
        component: fpbmzy
      },
      {
        path:'/zygl',
        name: 'zygl',
        component: zygl
      },
      {
        path: '/finallist',
        name: 'finallist',
        component: finallist
      },
      {
        path: '/risklist',
        name: 'risklist',
        component: risklist
      },
      {
        path: '/platformInstitutions',
        name: 'platformInstitutions',
        component: platformInstitutions
      },
      {
        path: '/apikeyplatformInstitutions',
        name: 'apikeyplatformInstitutions',
        component: apikeyplatformInstitutions
      },
      //订阅管理
      {
        path: '/SubscriptionManagement',
        name: 'SubscriptionManagement',
        component: SubscriptionManagement
      },
      {
        path: '/ipwhiteplatformInstitutions',
        name: 'ipwhiteplatformInstitutions',
        component: ipwhiteplatformInstitutions
      },
      {
        path: '/casend',
        name: 'casend',
        component: casend
      }
    ]
  },
  {
    path: '/login',
    name: 'login',
    component: login
  },
]

// const router = createRouter({
//   history: createWebHashHistory(),
//   routes
// })
const router = createRouter({
  // 使用createWebHistory创建历史模式的路由
  // history: createWebHistory(),
  history: createWebHashHistory(),
  routes,
  scrollBehavior(to, from, savedPosition) {
    // 始终滚动到顶部
    return {
      top: 0,
      behavior: 'auto'
    }; // behavior: 'smooth' 为平滑滚动
  },
});

// 定义白名单，添加 xq 对应的路径
const whiteList = ['/login'];

router.beforeEach((to, from, next) => {
  const token = localStorage.getItem('token');
  if (whiteList.includes(to.path)) {
    // 如果在白名单中，直接放行
    // window.topkai()
    next();
  } else if (!token) {
    // 不在白名单且没有 token，重定向到登录页
    next('/login');

  } else {
    // window.topguan()
    // 有 token，正常访问
    next();
  }
});

export default router
